const ClickCard = "Click Card";
const ClickCardAction = "Click_Card_Action";

export default ClickCard;
export { ClickCard, ClickCardAction };
